import "./DashboardPage.css";

function serializeTemplateAreas(areas) {
  return areas
    .map((row) => Array.isArray(row) ? row.join(" ") : row)
    .map((row) => `"${row}"`)
    .join(" ");
}

function normalizeTrack(track) {
  if (typeof track === "string") {
    return track;
  }

  if (track?.size === "fill") {
    return "minmax(0, 1fr)";
  }

  if (track?.size === "fixed") {
    return track.value ?? "auto";
  }

  throw new Error("DashboardPage track definitions must be strings or { size: 'fixed' | 'fill' } objects.");
}

function normalizeTrackList(tracks) {
  if (typeof tracks === "string") {
    return tracks;
  }

  if (!Array.isArray(tracks)) {
    throw new Error("DashboardPage track lists must be strings or arrays.");
  }

  return tracks.map(normalizeTrack).join(" ");
}

export function createDashboardLayout({
  columns,
  rows,
  areas,
  gap = "var(--layout-dashboard-gap)"
}) {
  return {
    columns: normalizeTrackList(columns),
    rows: normalizeTrackList(rows),
    areas,
    gap
  };
}

export function DashboardPage({ layout, slots }) {
  return (
    <section
      class="dashboard-page"
      style={{
        "--dashboard-columns": layout.columns,
        "--dashboard-rows": layout.rows,
        "--dashboard-areas": serializeTemplateAreas(layout.areas),
        "--dashboard-gap": layout.gap,
        "--layout-gap": layout.gap
      }}
    >
      {slots.map((slot) => (
        <div
          class={`dashboard-slot${slot.scroll ? " scroll" : ""}${slot.fill !== false ? " fill" : ""}${slot.className ? ` ${slot.className}` : ""}`}
          style={{ gridArea: slot.area }}
          key={slot.key}
        >
          {slot.content}
        </div>
      ))}
    </section>
  );
}
